import axiosInstance from "@/api/axios-instance";

export async function updateAvailability() {
  const response = await axiosInstance.get(`/calendly/updateOnDemand`);
  
  if (!response.data.success) {
    throw new Error(response.data.error || "Failed to update availability");
  }
  
  return response.data;
} 